import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "primereact/checkbox";

function GroupForm({ forwardedRef, className = "", model = [], disabled: _disabled, readOnly }) {
  const disabled = readOnly || _disabled;
  const [state, setState] = React.useState({ model });

  const validate = React.useCallback(() => {
    const { model } = state;
    return model;
  }, [state]);

  const getModel = React.useCallback(
    (noValidate) => validate(noValidate),
    [validate],
  );
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const onCheckboxChange = React.useCallback(
    (event) => {
      let newModel = [...state.model];
      if (event.checked) newModel.push(event.value);
      else newModel.splice(newModel.indexOf(event.value), 1);
      setState({ model: newModel });
    },
    [state],
  );

  const createCheckbox = React.useCallback(
    (prefix) => (value, index) => (
      <div key={index} className="p-col-12" id={value.split(" ").join("")}>
        <Checkbox
          id={`checkbox-${prefix}${index}`}
          inputId={`${prefix}${index}`}
          data-test-id={`${prefix}${index}`}
          value={value}
          onChange={onCheckboxChange}
          checked={state.model.includes(value)}
          disabled={disabled}
        ></Checkbox>
        <label htmlFor={`${prefix}${index}`} className="p-checkbox-label">
          {value}
        </label>
      </div>
    ),
    [state, onCheckboxChange, disabled],
  );

  const col1 = ["NE5", "NE4"].map(createCheckbox("group-cb1-"));
  const col2 = ["NE3", "TB"].map(createCheckbox("group-cb2-"));
  const col3 = ["GF", "Q-Prüfung"].map(createCheckbox("group-cb3-"));

  return (
    <div className={className}>
      <div className="neg-margin-lr">
        <div className="w3-row">
          <div className="w3-col s4 pad-lr">{col1}</div>
          <div className="w3-col s4 pad-lr">{col2}</div>
          <div className="w3-col s4 pad-lr">{col3}</div>
        </div>
      </div>
    </div>
  );
}

GroupForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <GroupForm {...props} forwardedRef={ref} />
));
